import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35326070"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-group d-flex flex-wrap position-relative align-items-center justify-content-end" }
const _hoisted_2 = { class: "list-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!
  const _component_action_button = _resolveComponent("action-button")!
  const _component_workspace_dropdown = _resolveComponent("workspace-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.memberAvatars, (member) => {
      return (_openBlock(), _createBlock(_component_avatar, {
        key: member._id,
        name: member.name,
        size: _ctx.size,
        class: "avatar-group-item fw-bold m-0"
      }, null, 8, ["name", "size"]))
    }), 128)),
    (_ctx.limited > 0)
      ? (_openBlock(), _createBlock(_component_action_button, {
          key: 0,
          class: "rounded-pill p-0 text-white fw-bold dropdown dropdown-toggle",
          "data-bs-toggle": "dropdown",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMoreMembers = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" +" + _toDisplayString(_ctx.limited), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_workspace_dropdown, {
      title: "Members",
      show: _ctx.showMoreMembers,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreMembers = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "list-group-item px-0 d-flex gap-2 justify-content-start align-items-center",
              key: member._id
            }, [
              _createVNode(_component_avatar, {
                name: member.name,
                size: _ctx.size
              }, null, 8, ["name", "size"]),
              _createElementVNode("span", null, "(" + _toDisplayString(member.email) + ")", 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}